/**
 * plugins/accessibilityFix.js
 *
 * A plugin to fix accessibility issues with aria-hidden and focus
 */

export default {
  install: (app) => {
    // Wait for the app to be mounted before setting up the observer
    app.mixin({
      mounted() {
        // Only set up the observer once at the root component
        if (this === this.$root) {
          setupAccessibilityFix();
        }
      }
    });
  }
};

function setupAccessibilityFix() {
  // Create a MutationObserver to watch for changes to the DOM
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // Check for attribute changes
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        const target = mutation.target;

        // If aria-hidden is true, add the inert attribute
        if (target.getAttribute('aria-hidden') === 'true') {
          target.setAttribute('inert', '');
        } else {
          // If aria-hidden is removed or set to false, remove the inert attribute
          target.removeAttribute('inert');
        }
      }

      // Check for added nodes with aria-hidden
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check the added node
            if (node.getAttribute('aria-hidden') === 'true') {
              node.setAttribute('inert', '');
            }

            // Check all descendants with aria-hidden
            const hiddenElements = node.querySelectorAll('[aria-hidden="true"]');
            hiddenElements.forEach((el) => {
              el.setAttribute('inert', '');
            });
          }
        });
      }
    });
  });

  // Start observing the document with the configured parameters
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['aria-hidden'],
    childList: true,
    subtree: true
  });

  // Initial scan for existing elements with aria-hidden="true"
  const hiddenElements = document.querySelectorAll('[aria-hidden="true"]');
  hiddenElements.forEach((el) => {
    el.setAttribute('inert', '');
  });
}
